import "./styles.scss";

export function UnauthenticatedPage() {
    return (
        <div className="unauthenticated-page">
            <p>It appears your login has failed.</p>
        </div>
    );
}
